import * as React from "react";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkCardAloha } from "uitk-react-cards";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-experimental-images";
import { UitkImageSkeleton, UitkTextSkeleton } from "uitk-react-skeleton";
import { liveAnnounce } from "uitk-react-utils";
import { useLocalization } from "@shared-ui/localization-context";

const results: string[] = new Array(10).fill(null).map((_, id) => `hotel-placeholder-${id}`);

export const PlaceholderResults: React.FC = () => {
  const { formatText } = useLocalization();

  liveAnnounce(formatText("propertyfilters.results.loading"));

  return (
    <div data-testid="loading-hotels">
      {results.map((key) => {
        return (
          <UitkSpacing margin={{ block: "four", inline: "four" }} key={key}>
            <UitkCardAloha>
              <UitkLayoutGrid columns={3} dataTestId="placeholder-card">
                <UitkLayoutGridItem colSpan={1}>
                  <UitkFigure
                    ratio={UitkFigureAspectRatioType.R16_9}
                    className="uitk-card-roundcorner-top-left uitk-card-roundcorner-bottom-left"
                  >
                    <UitkImageSkeleton />
                  </UitkFigure>
                </UitkLayoutGridItem>
                <UitkLayoutGridItem colSpan={2}>
                  <UitkSpacing padding={{ block: "two", inline: "two" }}>
                    <div>
                      <UitkSpacing margin={{ blockend: "two" }}>
                        <UitkTextSkeleton animation={true} type="primary" />
                      </UitkSpacing>
                      <UitkSpacing margin={{ blockend: "two" }}>
                        <UitkTextSkeleton animation={true} type="secondary" />
                      </UitkSpacing>
                    </div>
                  </UitkSpacing>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
            </UitkCardAloha>
          </UitkSpacing>
        );
      })}
    </div>
  );
};

export default PlaceholderResults;
